const SUPPORT_LINK = 'https://support.simera.io/knowledge';

export default SUPPORT_LINK;
